import { render, staticRenderFns } from "./PickUp.vue?vue&type=template&id=4a2aac2d&"
import script from "./PickUp.vue?vue&type=script&lang=js&"
export * from "./PickUp.vue?vue&type=script&lang=js&"
import style0 from "./PickUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports